const riot = require('riot');

riot.tag2('module-header', '<div class="bg-primary-light text-white"> <div class="statusbar"></div> <div class="container h60"> <div class="h-full f fh relative px16"> <h1 class="fs15 bold"><a class="block fs18 fw6" href="/">{opts.title}</a></h1> <div class="absolute t0 l0 h-full f fh px9 cursor-pointer" if="{opts.back}" onclick="{back}"><i class="fs36 icon-arrow_left"></i></div> <div class="absolute t0 l0 h-full f fh px9 cursor-pointer" if="{opts.close}" onclick="{goIndexPage}"><i class="fs36 icon-close"></i></div> <div class="absolute t0 r0 h-full f fh px9 pt3 cursor-pointer fs13 bold"> <yield from="right"></yield> </div> </div> </div> </div>', 'module-header,[data-is="module-header"]{display:block} module-header .box-shadow,[data-is="module-header"] .box-shadow{box-shadow:0 4px 5px rgba(1,40,64,0.1)}', '', function(opts) {
    this.openMenu = () => {
      spat.modal.open('modal-menu')
    };

    this.back = () => {
      history.back();
    };

    this.goIndexPage = () => {
      spat.router.push('/');
    };
});